// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__y+bcb","crit":"Pill_crit__Imaxv","warn":"Pill_warn__eQX3g","good":"Pill_good__nWpvj","info":"Pill_info__NnzTW","neutral":"Pill_neutral__DNUS+"};